<!--
  Note: Use only this component for a view (any components defined at this level @/app.vue)
        Make sure to wrap a div before to keep the style of the view
-->

<template>
  <div>
    <slot />
  </div>
</template>

<script>
import cssVariables from "@/assets/variables.scss";
import { getValueNumber } from "@/utils/common-utils";

export default {
  data() {
    return {
      innerWidth: window.innerWidth,
    };
  },
  computed: {
    getMainLayoutPadding() {
      if (this.$mq === "xl") {
        return {
          padding: `0px ${
            (this.innerWidth - getValueNumber(cssVariables.mediaLg)) / 2
          }px`,
        };
      }

      return {};
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  },
};
</script>
